export class UserAdminEventType {

	static USER_ADMIN_EDIT = 'USER_ADMIN_EDIT';
	static USER_ADMIN_PUSH = 'USER_ADMIN_PUSH';
	static USER_TABLE_UPDATE = 'USER_TABLE_UPDATE';
	static USER_CONFIRM = 'USER_CONFIRM';
	static USER_FORM = 'USER_FORM';
	static USER_ADMIN_DELETE = 'USER_ADMIN_DELETE';

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/user-admin/user-admin.event.type.ts